import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { DateComponent, IllustrationComponent, LineLoaderComponent } from '@ftr/foundation'
import { LineItemTypeIconPipe } from '~app/order-shared/line-item-type-icon/line-item-type-icon.pipe'
import { LiveIndicatorComponent } from '~app/shared/live-indicator/live-indicator.component'
import { PaginationComponent } from '~app/shared/pagination/pagination.component'
import { SharedModule } from '~app/shared/shared.module'
import { SidePanelPageLayoutComponent } from '~app/shared/side-panel-page-layout/side-panel-page-layout.component'
import { CourtSystemTimezoneModule } from '../to-court-system-timezone/court-system-timezone.module'
import { SearchResultsNavigationComponent } from './search-results/navigation/search-results-navigation.component'
import { SearchResultsNotFoundComponent } from './search-results/not-found/search-results-not-found.component'
import { SearchResultsAllRecordingsItemComponent } from './search-results/search-results-all-recordings-item/search-results-all-recordings-item.component'
import { HighlightHtmlPipe } from './search-results/search-results-item/highlight-html.pipe'
import { SearchResultsItemComponent } from './search-results/search-results-item/search-results-item.component'
import { SearchResultsListComponent } from './search-results/search-results-list/search-results-list.component'
import { SearchResultsOrdersItemComponent } from './search-results/search-results-orders-item/search-results-orders-item.component'
import { SearchResultsThisRecordingItemComponent } from './search-results/search-results-this-recording-item/search-results-this-recording-item.component'
import { SearchResultsComponent } from './search-results/search-results.component'

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    CourtSystemTimezoneModule,
    IllustrationComponent,
    HighlightHtmlPipe,
    LineItemTypeIconPipe,
    SidePanelPageLayoutComponent,
    LiveIndicatorComponent,
    PaginationComponent,
    LineLoaderComponent,
    DateComponent,
  ],
  declarations: [
    SearchResultsNotFoundComponent,
    SearchResultsComponent,
    SearchResultsItemComponent,
    SearchResultsListComponent,
    SearchResultsNavigationComponent,
    SearchResultsOrdersItemComponent,
    SearchResultsAllRecordingsItemComponent,
    SearchResultsThisRecordingItemComponent,
  ],
  exports: [
    SearchResultsNotFoundComponent,
    SearchResultsComponent,
    SearchResultsItemComponent,
    SearchResultsListComponent,
    SearchResultsNavigationComponent,
  ],
})
export class SearchModule {}
